import { ref, Ref } from 'vue';
import { useErrorToast } from './useToast';

// Generic composable for fetching and transforming API data
export function useFetchData<T>() {
  const data: Ref<T[]> = ref([]);
  const loading: Ref<boolean> = ref(false);
  const { showErrorToast } = useErrorToast();

  async function fetchData<R>(
    apiCall: () => Promise<{ statusCode: number; body?: R[] }>,
    mapFn: (item: R[]) => T[]
  ) {
    loading.value = true;
    try {
      const response = await apiCall();

      if (response.statusCode === 200 && Array.isArray(response.body)) {
        data.value = mapFn(response.body);
      } else if (response.statusCode !== 404) {
        showErrorToast();
        data.value = [];
      }
    } catch (error) {
      showErrorToast();
      data.value = [];
    } finally {
      loading.value = false;
    }
  }

  return {
    data,
    loading,
    fetchData,
  };
}
